
import Star from '@mui/icons-material/Star';
import React from 'react';

export const StarIcon = () => (
  <Star color={'primary'} />
);